// extracted by mini-css-extract-plugin
module.exports = {"navigation-button":"style_navigation-button__hHvFD","left":"style_left__4Jf6F","right":"style_right__gAQOr","navigation-button-icon":"style_navigation-button-icon__cXp1_"};